export const environment = {
    "production": false,
    "serverUrl": "http://localhost:3000",
    "serverHostAndPort": "localhost:3000",
    "MovieDbApi": "459a01667bfdbadaac975614edd2b261"
};